import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: TopicPagePaginatedTrendingPetitionsDataContext,
	Provider: TopicPagePaginatedTrendingPetitionsDataContextProvider,
	useContext: useTopicPagePaginatedTrendingPetitionsData,
	useAsyncData: useTopicPagePaginatedTrendingPetitionsDataFromApi,
	prefetchAsyncData: prefetchTopicPagePaginatedTrendingPetitionsDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'TopicPagePaginatedTrendingPetitionsDataContext',
	dataProperty: 'trendingPetitionsPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler(),
});
